import * as types from "../mutation-type";

const state = {
  userInfo: "",
};

const actions = {
  setUserInfo ( { commit }, info ) {
    commit( types.SET_USERINFO, info );
  }
};

const getters = {
  userInfo: ( state ) => state.userInfo
};

const mutations = {
  [types.SET_USERINFO] ( state, info ) {
    state.userInfo = info;
  }
};

export default {
  state,
  getters,
  mutations,
  actions,
};
